import { IconKcal, IconVol } from "@/components/icon/master"
import { Selector } from "@/components/shared/Selector"
import { TCocktailDetailTanquerayProps } from "../type"
import { useEffect, useState } from "react"
import { TCocktail } from "@/shared/types"
import { DdpCta } from "@/components/shared/DdpCta"
import { SingleImg } from "@/components/shared/SingleImg"
import { useCmsStore } from "@/components/AppHooks"
import { useSearchParams } from "next/navigation"

export function CraftingContainer(props: TCocktailDetailTanquerayProps & { cocktainInfo: TCocktail }) {
    const [selected, setSelected] = useState<string | null>(null)
    const searchParams = useSearchParams()
    const cocktailId = searchParams?.get('cocktailId')
    useEffect(()=>{
        setSelected(null)
    }, [cocktailId])
    const { cocktainInfo } = props;
    const { storeConfig: {
        changeMlToOz,
        cocktailList,
        newTabForProductDetail
    } } = useCmsStore()!
    const linkProps = newTabForProductDetail ? { target: '_blank' } : { target: '' };
    const productCallBackUrl = cocktailList.find((item) => item.cocktailID.name === cocktainInfo.id)?.productCallbackURL || '';
    const type = changeMlToOz ? 'oz' : 'ml'
    function calculateUnit(ml: string, oz: string) {
        if (!ml && !oz) {
            return '';
        }
        if (type === 'ml') {
            if (ml) {
                return parseInt(selected || '1') * Number(ml) + ' ml';
            }
            return parseInt(selected || '1') * Number(oz || '0') + ' oz';
        }
        if (type === 'oz') {
            if (oz) {
                return parseInt(selected || '1') * Number(oz) + ' oz';
            }
            return parseInt(selected || '1') * Number(ml || '0') + ' ml';
        }
    }
    function validateUrl() {
        const url = cocktainInfo.productUrlEcommerce
        if (!url) {
            return false
        }
        return url.startsWith('http') || url.startsWith('https') || url.startsWith('/')
    }
    const showEcommerceWrapper = validateUrl() || cocktainInfo.productDescriptionEcommerce || cocktainInfo.productImageEcommerce?.url || cocktainInfo.productTitleEcommerce
    return <div className="crafting-container">

        <div className="top-basic-wrapper">
            <div className="left-title-container">
                <div className="title">{props.titleEssential}</div>
                <div className="tag-list">
                    {
                        cocktainInfo.calorie && <div className="tag-item">
                            <IconKcal />
                            <div className="tag-text">{cocktainInfo.calorie} {props.unitCalories}</div>
                        </div>
                    }
                    {/* {
                        cocktainInfo.alcoholVol && <div className="tag-item">
                            <IconVol />
                            <div className="tag-text">{cocktainInfo.alcoholVol}{props.unitVol}</div>
                        </div>
                    } */}
                </div>
            </div>

            <div className="select-wrapper">
                <Selector
                    className="people-select"
                    options={Array.from({ length: 5 }, (_, i) => ({
                        label: `${i + 1}  ${i === 0 ? props.stringPerson : props.stringPeople}`,
                        value: `${i + 1}`
                    }))}
                    selected={selected}
                    defaultValue={props.stringNumberOfServes}
                    onSelect={(value) => {
                        setSelected(value)
                    }}
                />
                {cocktainInfo.alcoholVol && <div className="selected-result-wrapper">
                    <IconVol />
                    <span className="selected-text">{cocktainInfo.alcoholVol} {props.stringUnitsOfAlcoholPerServe}</span>
                </div>}

            </div>
        </div>

        <div className="big-layout-content-wrapper ">
            <div className="top-wrapper">
                <div className="ingredients-wrapper">
                    <div className="ingredients-title">{props.titleIngredient}</div>
                    <div className="list-wrapper">
                        {cocktainInfo?.ingredients?.map((item, index) => (
                            <div key={index} className="ingredient-item">
                                {item.quantity && parseInt(selected || '1') * Number(item.quantity)}
                                {calculateUnit(item.quantity_ml, item.quantity_oz) + ' ' + item.ingredient}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="equipment-wrapper">
                    <div className="equipment-title">{props.titleEquipment}</div>
                    <div className="list-wrapper">
                        {cocktainInfo?.equipment?.map((item, index) => (
                            <div key={index} className="equipment-item">
                                {/* {calculateUnit(item.quantity, item.quantity) + ' ' + item.equipment} */}
                                {item.equipment}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {
                showEcommerceWrapper && <div className="ecommerce-wrapper">
                    <div className="ecommerce-media--wrapper">
                        {
                            cocktainInfo.productImageEcommerce?.url && <SingleImg className="ecommerce-media" image={cocktainInfo.productImageEcommerce} />
                        }
                    </div>
                    <div className="ecommerce-content-wrapper">
                        <div className="ecommerce-title">{cocktainInfo.productTitleEcommerce}</div>
                        <div className="ecommerce-desc">{cocktainInfo.productDescriptionEcommerce}</div>
                        {
                            productCallBackUrl && <DdpCta className="ecommerce-cta" cta={{
                                text: props.cTANameEcommerce,
                                show: true,
                                url: productCallBackUrl
                            }}
                            {...linkProps}
                            >
                            </DdpCta>
                        }
                    </div>

                </div>
            }

        </div>



    </div>
}